import { getService } from "../../axios/services";

export function getContentAssessments({ contentId }) {

  return getService({
    endpoint: `Assessments/contents/${contentId}`,
    api: "v2",
  });
}
